import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showRemoveDebtModal: false,
  showBulkWriteOffModal: false,
  editDebtModalParams: null,
}

// TODO add ts types to params
const billingSlice = createSlice({
  name: 'billing',
  initialState,
  reducers: {
    openRemoveDebtModal: (state) => {
      state.showRemoveDebtModal = true;
    },
    closeRemoveDebtModal: (state) => {
      state.showRemoveDebtModal = false;
    },
    openBulkWriteOffModal: (state) => {
      state.showBulkWriteOffModal = true;
    },
    closeBulkWriteOffModal: (state) => {
      state.showBulkWriteOffModal = false;
    },
    setEditDebtModalParams: (state, action) => {
      state.editDebtModalParams = action.payload;
    },
    clearEditDebtModalParams: (state) => {
      state.editDebtModalParams = null;
    },
  },
});

export const selectShowRemoveDebtModal = (state) => !!state.billing.showRemoveDebtModal;
export const selectShowBulkWriteOffModal = (state) => !!state.billing.showBulkWriteOffModal;
export const selectShowEditDebtModal = (state) => !!state.billing.editDebtModalParams;
export const selectEditDebtModalParams = (state) => state.billing.editDebtModalParams;

export const {
  openRemoveDebtModal,
  closeRemoveDebtModal,
  openBulkWriteOffModal,
  closeBulkWriteOffModal,
  setEditDebtModalParams,
  clearEditDebtModalParams,
} = billingSlice.actions;

export default billingSlice.reducer;